import {} from "../../request/api";
const state = {
    map: null,
    airLocationInfoList: [],
};
const mutations = {
    changeMap(state, map) {
        state.map = map;
    },

};
const actions = {
    initMapDataAction(context, map) {
        context.commit('changeMap', map);
    },
    airLocationInfoListAction(context, list) {
        context.commit('changeMap', list);
    }

};

const getters = {

};

export default {
    state,
    mutations,
    actions,
    getters,
    // 命名空间
    namespaced: true, //使用命名空间
}